import { graphql } from '@teachino/shared-infrastructure';
import { topicDetailsFragment } from './topic-details.fragment';

export const topicDetailsQuery = graphql(
  `
    query TopicDetails($topicId: String!, $courseId: String) {
      topicContent(topicIdInput: { id: $topicId }) {
        ...TopicDetails
      }
      interactiveAssignmentsStatusByTopic(
        interactiveAssignmentStatusByTopicInput: {
          courseId: $courseId
          topicId: $topicId
        }
      ) {
        materialId
        started
      }
    }
  `,
  [topicDetailsFragment],
);
